<script>
import Vue from 'vue';
import { Event } from '@/models/Event';
import { userIsStaff } from '@/helpers/auth';
import { delayed } from '@/helpers/tools';

export default Vue.extend({
    name: 'CompactViewEventDescription',
    props: {
        record: Event,
    },
    data() {
        return userIsStaff()
            ? {
                  // Config for staff users:
                  tmceConfig: {
                      toolbar1:
                          'link unlink | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | paste',
                      toolbar2: 'template | image media | code | fullscreen | undo redo',
                      body_id: 'agendaPage_get',
                      body_class: 'agenda mce-editor-body',
                      max_height: 500,
                  },
              }
            : {
                  // Config for non-staff (veranstalter) users:
                  tmceConfig: {
                      toolbar1: 'link unlink | bold italic | paste |code | fullscreen | undo redo',
                      toolbar2: null,
                      body_id: 'agendaPage_get',
                      body_class: 'agenda mce-editor-body',
                      paste_data_images: false,
                      paste_block_drop: false,
                      max_height: 500,
                  },
              };
    },
    created() {
        this.userIsStaff = userIsStaff;
    },
    methods: {
        onInput: delayed(function (newVal) {
            if (newVal !== this.record.description) {
                this.$emit('propertyChange', { property: 'description', value: newVal });
            }
        }, 1000),
    },
});
</script>

<template>
    <div>
        <h3 class="section-heading">{{ $t('description_text') }}</h3>
        <TinymceEditor
            :value="record.description"
            :init="tmceConfig"
            :placeholder="$t('event_description_placeholder')"
            @input="onInput"
        />
    </div>
</template>

<style lang="scss" scoped>
.class-selection {
    margin-top: 5px !important;
}
.radio-equal {
    flex-grow: 1;
    width: 49%;
    margin-right: 0 !important;
}
</style>
